import { wellnub } from '../wellnub.api';

export const patchUserStatus = payload =>
  wellnub.patch(`/v1/admin/user/${payload.id}`, payload.data);
